import React from 'react';
import PropTypes from 'prop-types';
import PictionJS from 'piction-js';
import classNames from 'classnames';
import _ from 'lodash';
import { List } from 'immutable';
import appConfig from '../../appConfig';
import UMOGridItem from '../UMOGridItem';
import UMOGridItemRatings from './UMOGridItemRatings';
import { SearchParams } from '../../utils/searchUtils';

// serves as a wrapper for non justified grid item component
function UMOGridNoJItem({
  umo,
  customMetatag,
  umoRatings,
  onDetailViewClick,
  toggleFullImageView,
  selectedWorkspaceData,
  retrieveAlternateUMOs,
  dispatch,
  isSelected,
  isUMOGalleryWorkspace,
  searchParams,
  selectedUMOIDs,
  isSelectAll,
  workspaceCardsViewTimes,
  highlightSetID,
  galleryType,
}) {
  const tombstoneList = umo.tombstoneMetadataList.all.map(
    (tombstoneItem, i) => (
      <li
        key={i}
        className={classNames('umo-grid-item-info__item', {
          'umo-grid-item-info__item--header': i === 0,
        })}
      >
        {appConfig.tombstoneCharacterLimit &&
        _.isNumber(appConfig.tombstoneCharacterLimit)
          ? _.truncate(tombstoneItem.value, {
              length: appConfig.tombstoneCharacterLimit,
            })
          : tombstoneItem.value}
      </li>
    )
  );

  const ratings = umoRatings.display ? (
    <UMOGridItemRatings
      umo={umo}
      ratingsConfig={umoRatings}
      dispatch={dispatch}
    />
  ) : (
    ''
  );

  return (
    <div
      className={classNames('umo-grid-item-noj', {
        'umo-grid-item-noj--selected': isSelected,
      })}
    >
      <UMOGridItem
        onDetailViewClick={onDetailViewClick}
        toggleFullImageView={toggleFullImageView}
        isNotJustified
        umo={umo}
        customMetatag={customMetatag}
        searchParams={searchParams}
        selectedUMOIDs={selectedUMOIDs}
        isSelectAll={isSelectAll}
        isSelected={isSelected}
        selectedWorkspaceData={selectedWorkspaceData}
        isUMOGalleryWorkspace={isUMOGalleryWorkspace}
        retrieveAlternateUMOs={retrieveAlternateUMOs}
        dispatch={dispatch}
        workspaceCardsViewTimes={workspaceCardsViewTimes}
        highlightSetID={highlightSetID}
        galleryType={galleryType}
        isSelectableItem={true}
      />
      {ratings}
      <div className="umo-grid-item-info">{tombstoneList}</div>
    </div>
  );
}

UMOGridNoJItem.propTypes = {
  umo: PropTypes.instanceOf(PictionJS.UMO).isRequired,
  selectedUMOIDs: PropTypes.instanceOf(List),
  searchParams: PropTypes.instanceOf(SearchParams),
  isSelectAll: PropTypes.bool,
  isSelected: PropTypes.bool,
  isUMOGalleryWorkspace: PropTypes.bool,
  onDetailViewClick: PropTypes.func,
  toggleFullImageView: PropTypes.func,
  dispatch: PropTypes.func,
  retrieveAlternateUMOs: PropTypes.func,
  selectedWorkspaceData: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    description: PropTypes.string,
  }),
  customMetatag: PropTypes.string,
  umoRatings: PropTypes.instanceOf(Object),
  workspaceCardsViewTimes: PropTypes.shape({
    catid: PropTypes.string,
    usernm: PropTypes.string,
    viewtimes: PropTypes.array,
  }),
  highlightSetID: PropTypes.string,
  galleryType: PropTypes.string,
};

export default UMOGridNoJItem;
